import type { ComponentType } from 'react';
import type { RouteObject } from 'react-router-dom';

/**
 * React Router v7 lazy 로딩 래퍼
 */
export function lazyRoute(
  importFn: () => Promise<{ default: ComponentType }>,
): Pick<RouteObject, 'lazy'> {
  return {
    lazy: async () => {
      const { default: Component } = await importFn();
      return { Component };
    },
  };
}


/**
 * Lazy 고의 딜레이. (Spinner Test)
 */
// const ARTIFICIAL_DELAY_MS = 2000; // 2초
//
// export function lazyRoute(
//   importFn: () => Promise<{ default: ComponentType }>,
// ): Pick<RouteObject, 'lazy'> {
//   return {
//     lazy: async () => {
//       if (import.meta.env.DEV) {
//         await new Promise((r) => setTimeout(r, ARTIFICIAL_DELAY_MS));
//       }
//       const { default: Component } = await importFn();
//       return { Component };
//     },
//   };
// }
